// 请写下当前页面备注
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useEffect } from 'react'
import { Card, theme } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'



function YourName () {
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数
  const {
    token: { colorBgContainer, colorText },
  } = theme.useToken(); //获取主题颜色

  const [loading, setLoading] = useState(false)//加载中···


  useEffect(() => {

    // eslint-disable-next-line
  }, [])

  return (
    <Card>
      <div className='box h20 border flex jcc align_center radius4' style={{ backgroundColor: '#FFBD0A', display: 'inline-block' }}>
        <span className='fs12 fw600 lh18' style={{ color: '#000' }}>1111111111111111111111</span>
      </div>
    </Card>
  )
}
export default YourName;